export default {
    driver_performance_events_asset_id: "AssetID",
    driver_performance_events_asset_name: "Asset Name",
    driver_performance_events_asset_no_asset_info: "No Asset information available.",
};